import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination } from "@/components/molecules/Pagination";
import { PaginationType } from "@/models/common";
import { TableContainer } from "@mui/material";
import { CarNoopReasonedEventsConstants, getNoopReasonLabel, getRestartPlanLabel } from "./CarNoopReasonedEventsConstants";
import { EvCarNoopEvents } from "@/models/carUnderuseEvents";
import { formatDateStr, getShortDatetime } from "@/util/datetime";

export type CarNoopReasonedEventsListProps = {
  onChangePage: (page: number) => void;
  pagingData: PaginationType;
  events: EvCarNoopEvents[];
};

export const CarNoopReasonedEventsList = (props: CarNoopReasonedEventsListProps) => {
  const {
    onChangePage,
    events,
    pagingData,
  } = props;

  return (
    <React.Fragment>
      <TableContainer className="table-container-width">
        <Table size="small" className="list-head">
          <TableHead>
            <TableRow>
              <TableCell>
                {CarNoopReasonedEventsConstants.CompanyOffice}
              </TableCell>
              <TableCell>
                {CarNoopReasonedEventsConstants.RadioNumber}
              </TableCell>
              <TableCell>
                {CarNoopReasonedEventsConstants.NoopStartDate}
              </TableCell>
              <TableCell>
                {CarNoopReasonedEventsConstants.EventAt}
              </TableCell>
              <TableCell>
                {CarNoopReasonedEventsConstants.NoopReason}
              </TableCell>
              <TableCell>
                {CarNoopReasonedEventsConstants.RestartPlanDate}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((row) => (
              <TableRow key={row.eventId} hover sx={{ wordBreak: "break-all" }}>
                <TableCell>
                  {row.officeName}
                </TableCell>
                <TableCell>
                  {row.vehicleCode}
                </TableCell>
                <TableCell>
                  {formatDateStr(row.noopStartDate)}
                </TableCell>
                <TableCell>
                  {getShortDatetime(row.eventAt)}
                </TableCell>
                <TableCell>
                  {getNoopReasonLabel(row.noopReasonCode)}
                </TableCell>
                <TableCell>
                  {getRestartPlanLabel(row)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={pagingData.total}
        page={pagingData.page}
        size={pagingData.size}
        setPage={onChangePage}
      />
    </React.Fragment>
  );
};
